export const CONTACT_MODAL_TITLE = 'Contact'
export const CONTACT_MODAL_TITLE_NEW = 'New contact'
